/* src/app/indirect-rate/indirect-rate-structure/indirect-rate-structure-presenter/indirect-rate-structure.component.scss */
body#themeTag :host ::ng-deep button span.pi-trash {
  font-size: 1.5em !important;
}
/*# sourceMappingURL=indirect-rate-structure.component.css.map */
